"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .unit("pmol/L")
    .min(0.01)
    .max(30)
    .interpretation({ vocab: "htx", code: "t3" })
    .tag({ vocab: "snomed", code: "166324000" })
    .tag({ vocab: "loinc", code: "14928-6" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "396550006" })
    .tag({ vocab: "htx", code: "lab_endocrin" });
